import { useSearchParams } from 'react-router-dom';

export const useDraftId = () => {
  const [searchParams] = useSearchParams();
  const draftId = new URLSearchParams(searchParams).get('draftid');

  return draftId;
};
